import { api } from "assets/scripts/utilities/api-clients";

export const get = async () => {
  const response = await api.get("/kam/configuration");

  return response;
};
